<template>
  <v-flex xs12>
    <v-flex>
      <v-layout
        align-center
        justify-content-between
        :justify-center="xsScreen"
        :wrap="xsScreen"
        :class="[xsScreen ? 'py-2' : '']"
      >
        <v-flex class="f-16 mt-4">
          <p class="mb-0">
            {{ $t('family_card.document_section.further_story_instruction.title') }}
          </p>
          <p class="mb-0 pl-2">
            {{ $t('family_card.document_section.further_story_instruction.1') }}
          </p>
          <p class="mb-0 pl-2">
            {{ $t('family_card.document_section.further_story_instruction.2') }}
          </p>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-layout
        align-center
        justify-content-between
        class="documents-row"
        style="border: 0"
        :justify-center="xsScreen"
        :wrap="xsScreen"
        :class="[xsScreen ? 'py-2' : '']"
      >
        <v-flex
          xs6
          sm6
          md5
          xl4
          :class="[xsScreen ? 'mb-2' : '']"
        >
          <v-layout
            align-center
            wrap
          >
            <v-flex xs12>
              <v-layout align-center>
                <BaseIcon class="mr-2">
                  <FileIcon :icon-color="$vuetify.theme.sz_medium_grey" />
                </BaseIcon>
                <p class="mb-0 f-1">
                  <span class="fw-600">
                    {{ $t('family_card.document_section.further_story_instruction.notes') }}
                  </span>
                </p>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-spacer />
        <v-flex class="none-growth">
          <v-btn
            v-if="!readOnly"
            :to="addNoteLink"
            color="sz_violet"
            class="mx-0"
          >
            {{ $t('family_card.document_section.further_story_instruction.add') }}
          </v-btn>
          <router-link
            v-else-if="
              family.status.family_edition_status_id !== statusesId.STATUS_FINISHED_SUMMARY
            "
            :to="addNoteLink"
          >
            {{ $t('buttons.preview') }}
          </router-link>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-layout
        v-for="(item, index) in meetingNotes"
        :key="index"
        align-center
        justify-content-between
        class="documents-row"
        :justify-center="xsScreen"
        :wrap="xsScreen"
        :class="[xsScreen ? 'py-2 ml-1' : 'ml-5']"
      >
        <v-flex
          xs6
          sm6
          md5
          xl4
          :class="[xsScreen ? 'mb-2' : '']"
        >
          <v-layout
            align-center
            wrap
          >
            <v-flex xs12>
              <v-layout align-center>
                <BaseIcon class="mr-2">
                  <FileIcon :icon-color="$vuetify.theme.sz_medium_grey" />
                </BaseIcon>
                <p class="mb-0 f-1">
                  <span class="fw-600">
                    {{ $t('family_card.document_section.further_story_instruction.note') }}
                  </span>
                </p>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-spacer />
        <v-flex
          shrink
          :class="[xsScreen ? 'mb-2' : '']"
        >
          <p class="mb-0 f-1">
            <span class="fw-600">
              {{ formatDate(new Date(item.date), { revert: true, separator: '.'}) }}
            </span>
          </p>
        </v-flex>
        <v-spacer />
        <v-flex class="none-growth">
          <v-btn
            v-if="!readOnly"
            :to="noteLink(item.id)"
            :disabled="deleteLoader"
            color="sz_violet"
            class="mx-0 v-btn--small"
          >
            {{ $t('buttons.edit') }}
          </v-btn>
          <router-link
            v-else
            :to="noteLink(item.id)"
          >
            {{ $t('buttons.preview') }}
          </router-link>
          <v-btn
            v-if="!readOnly"
            :disabled="deleteLoader"
            :loading="deleteLoader && noteId === item.id"
            class="d-inline-flex v-btn v-btn--small v-btn--flat text-none"
            @click="confirmDelete(item.id)"
          >
            <baseIcon
              :width="18"
              :height="18"
              class="mr-1"
            >
              <CartIcon :icon-color="$vuetify.theme.sz_violet" />
            </baseIcon>
            <span>{{ $t('buttons.delete') }}</span>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="family.meeting_notes.length > minLength"
        class="justify-center mt-2"
      >
        <v-flex
          shrink
          @click="showMore = !showMore"
        >
          <a
            v-if="showMore"
            @click.prevent
          >{{ $t('family_card.changelog.show_less') }}</a>
          <a
            v-else
            @click.prevent
          >{{ $t('family_card.changelog.show_more') }}</a>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      v-if="isSummaryVisible"
      xs12
    >
      <v-layout
        align-center
        justify-content-between
        class="documents-row"
        style="border: 0"
        :justify-center="xsScreen"
        :wrap="xsScreen"
        :class="[xsScreen ? 'py-2' : '']"
      >
        <v-flex
          xs6
          sm6
          md5
          xl4
          :class="[xsScreen ? 'mb-2' : '']"
        >
          <v-layout
            align-center
            wrap
          >
            <v-flex xs12>
              <v-layout align-center>
                <BaseIcon class="mr-2">
                  <FileIcon :icon-color="$vuetify.theme.sz_medium_grey" />
                </BaseIcon>
                <p class="mb-0 f-1">
                  <span class="fw-600">
                    {{ $t('family_card.document_section.further_story_instruction.summary') }}
                  </span>
                </p>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-spacer />
        <v-flex class="none-growth">
          <v-btn
            v-if="!summaryReadOnly"
            color="sz_violet"
            class="mx-0"
            @click="openConfirmDialog"
          >
            {{ $t('buttons.edit') }}
          </v-btn>
          <router-link
            v-else
            :to="summaryLink"
          >
            {{ $t('buttons.preview') }}
          </router-link>
        </v-flex>
      </v-layout>
    </v-flex>
    <AppModal
      :close-button="true"
      :visible="showModal"
      persistent
      @close="closeModal"
    >
      <template slot="content">
        <p class="f-1 mb-0">
          {{ $t('further_story.note.modal') }}
        </p>
      </template>
      <template slot="actions">
        <v-layout wrap>
          <v-flex xs12>
            <v-divider class="mb-3" />
          </v-flex>
          <v-flex xs12>
            <v-layout
              align-center
              wrap
              :column="$vuetify.breakpoint.xsOnly"
              :justify-space-between="$vuetify.breakpoint.smAndUp"
            >
              <v-flex
                shrink
                order-xs2
                :mt-3="$vuetify.breakpoint.xsOnly"
                order-sm1
              >
                <a @click="closeModal">{{ $t('buttons.cancel') }}</a>
              </v-flex>
              <v-flex
                shrink
                order-xs1
                order-sm2
              >
                <v-btn
                  color="sz_violet"
                  @click="deleteNote"
                >
                  {{ $t('buttons.delete') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </AppModal>
    <AppModal
      :close-button="true"
      :visible="confirmDialog"
      persistent
      @close="closeConfirmModal"
    >
      <template slot="title">
        <h2 class="display-3 display-3_dark text-xs-left">
          {{ $t('further_story.summary.modal.title') }}
        </h2>
      </template>
      <template slot="content">
        <p class="f-1 mb-0">
          {{ $t('further_story.summary.modal.content') }}
        </p>
      </template>
      <template slot="actions">
        <v-layout wrap>
          <v-flex xs12>
            <v-divider class="mb-3" />
          </v-flex>
          <v-flex xs12>
            <v-layout
              align-center
              wrap
              :column="$vuetify.breakpoint.xsOnly"
              :justify-space-between="$vuetify.breakpoint.smAndUp"
            >
              <v-flex
                shrink
                order-xs2
                :mt-3="$vuetify.breakpoint.xsOnly"
                order-sm1
              >
                <a @click="closeConfirmModal">{{ $t('buttons.cancel') }}</a>
              </v-flex>
              <v-flex
                shrink
                order-xs1
                order-sm2
              >
                <v-btn
                  color="sz_violet"
                  :to="summaryLink"
                >
                  {{ $t('buttons.ok') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </AppModal>
  </v-flex>
</template>

<script>
import BaseIcon from '@/icons/BaseIcon';
import CartIcon from '@/icons/CartIcon';
import FileIcon from '@/icons/FileIcon';
import mainPage from '@/mixins/furtherStory/mainPage';
import AppModal from '@/components/widgets/AppModal.vue';
import { formatDate } from '@/utils/formatDate';

export default {
    name: 'FurtherStoryList',
    components: { AppModal, CartIcon, FileIcon, BaseIcon },
    mixins: [mainPage],
    data () {
        return {
            deleteLoader: false,
            showMore: false,
            noteId: null,
            minLength: 3,
            showModal: false,
            confirmDialog: false
        };
    },
    computed: {
        xsScreen () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        addNoteLink () {
            return { name: 'add-further-story-note', params: { familyId: this.$route.params.id } };
        },
        summaryLink () {
            return { name: 'further-story-summary', params: { familyId: this.$route.params.id } };
        },
        meetingNotes () {
            if (this.showMore) {
                return this.family.meeting_notes;
            }
            return this.family.meeting_notes.slice(0, this.minLength);
        }
    },
    methods: {
        formatDate,
        noteLink (noteId) {
            return { name: 'further-story-note', params: { familyId: this.$route.params.id, noteId } };
        },
        confirmDelete (noteId) {
            this.noteId = noteId;
            this.showModal = true;
        },
        closeModal () {
            this.showModal = false;
        },
        closeConfirmModal () {
            this.confirmDialog = false;
        },
        openConfirmDialog () {
            this.confirmDialog = true;
        },
        deleteNote () {
            this.closeModal();
            this.deleteLoader = true;
            this.$store
                .dispatch('furtherStory/deleteNote', {
                    familyId: this.$route.params.id,
                    noteId: this.noteId
                })
                .finally(() => {
                    this.deleteLoader = false;
                    this.noteId = null;
                });
        }
    }
};
</script>

<style scoped></style>
